import { useMutation } from '@apollo/client';
import {
  ADD_FAVORITE,
  REMOVE_FAVORITE,
  RUN_EDITED_TESTS_EXECUTION,
  STOP_RESUME_SCHEDULED_EXECUTION,
} from '../../GraphQL/TestExecutions/TRFX/Mutations';

export const useTestExecutionMutations = (rerunTestExecutionMutation) => {
  const [runEditedMutation] = useMutation(RUN_EDITED_TESTS_EXECUTION);
  const [removeFavorite] = useMutation(REMOVE_FAVORITE);
  const [addFavorite] = useMutation(ADD_FAVORITE);
  const [stopResumeScheduledExecution] = useMutation(
    STOP_RESUME_SCHEDULED_EXECUTION
  );

  const [rerunTestExecution] = useMutation(rerunTestExecutionMutation, {
    onCompleted: () => {
      window.hideMessage();
      window.flash('New execution was successfully created.', 'success');
    },
    onError: (error) => {
      window.hideMessage();
      window.flash(
        `The action could not be completed. Please review carefully the information provided or try later.`,
        'error'
      );
    },
  });

  return {
    runEditedMutation,
    removeFavorite,
    addFavorite,
    stopResumeScheduledExecution,
    rerunTestExecution,
  };
};
